import type { Store } from '@/stores/store'
import type { PopupInfo } from '@/stores/temp'
import type { CustomSetLocation } from '@/types/useCustomLocation'
import type { ModuleObject } from '@/util/modules'
import type { ComponentType } from 'react'
import { PopupButtonGoThere } from './PopupButtons/PopupButtonGoThere'
import { PopupButtonSchedules } from './PopupButtons/PopupButtonSchedules'
import { PopupContentPoi } from './PopupContent/PopupContentPoi'
import { PopupContentStop } from './PopupContent/PopupContentStop'
import { PopupTitleDefault } from './PopupTitle/PopupTitleDefault'

export type PopupLifecycleParams = {
	module: ModuleObject | null
	store: Store

	location: string
	search: string
	setLocation: CustomSetLocation
}
export type PopupContent = {
	Title: ComponentType<PopupInfo>
	Content: ComponentType<PopupInfo>
	buttons: ComponentType<PopupInfo>[]

	onMount?: (popup: PopupInfo, params: PopupLifecycleParams) => void
	onUnmount?: (popup: PopupInfo, params: PopupLifecycleParams) => void
}

export const popupContent: Record<string, PopupContent> = {}

const popupStopPoint = () => {
	popupContent.stop_point = {
		Title: PopupTitleDefault,
		Content: PopupContentStop,
		buttons: [PopupButtonSchedules, PopupButtonGoThere],

		onMount({ id }, { location, module, setLocation }) {
			if (module?.module === 'lines') {
				const parts = location.split('/')
				const linesIndex = parts.indexOf('lines')
				const linedIdIndex = parts[linesIndex + 1]
				const isThermo =
					linedIdIndex && linedIdIndex.startsWith('line:')
				const newLocation =
					module.path +
					'/' +
					location
						.slice(module.path.length + 1)
						.split('/')
						.slice(0, 2)
						.join('/') +
					'/' +
					id

				if (isThermo) {
					setLocation(newLocation)
				}
			}
		},

		onUnmount({ id }, { location, module, setLocation }) {
			if (module?.module !== 'lines') return
			const newLocation =
				module.path +
				'/' +
				location
					.slice(module.path.length + 1)
					.split('/')
					.slice(0, 2)
					.join('/')
			if (location !== newLocation + '/' + id) return
			setLocation(newLocation)
		},
	}
}

const popupStopArea = () => {
	popupContent.stop_area = {
		Title: PopupTitleDefault,
		Content: PopupContentStop,
		buttons: [PopupButtonSchedules, PopupButtonGoThere],

		onUnmount(_popup, { location, module, setLocation }) {
			if (module?.module !== 'lines') return
			const newLocation =
				module.path +
				'/' +
				location
					.slice(module.path.length + 1)
					.split('/')
					.slice(0, 2)
					.join('/')
			setLocation(newLocation)
		},
	}
}

const popupPoi = () => {
	popupContent.poi = {
		Title: PopupTitleDefault,
		Content: PopupContentPoi,
		buttons: [PopupButtonGoThere],

		onUnmount({ id }, { search, setLocation }) {
			if (
				new URLSearchParams(search)
					.get('poi')
					?.split('@')
					.slice(1)
					.join('@') === id
			)
				setLocation('', { removeParams: ['poi'] })
		},
	}
}

const loadPopup = () => {
	popupStopPoint()
	popupStopArea()
	popupPoi()
}
loadPopup()
